export const BASE_URL =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_HOST_ENV === 'development'
    ? `https://dev.goodpharm.kr/admin/`
    : `https://api.goodpharm.kr/admin/`;
